import { render, staticRenderFns } from "./NewMilk.vue?vue&type=template&id=9664016e&scoped=true"
import script from "./NewMilk.vue?vue&type=script&lang=js"
export * from "./NewMilk.vue?vue&type=script&lang=js"
import style0 from "./NewMilk.vue?vue&type=style&index=0&id=9664016e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9664016e",
  null
  
)

export default component.exports